import React from "react"; 

const RefundCancellationPolicy: React.FC = () => {
  return (
    <div className="policy-container" style={{
      maxWidth: 900,
      margin: "3rem auto",
      padding: "2rem 2.5rem",
      background: "#fff",
      borderRadius: 15,
      boxShadow: "0 10px 20px rgba(100, 65, 165, 0.15)",
      fontFamily: "'Poppins', sans-serif"
    }}>
      <h1 style={{ color: "#5B2A93", fontWeight: 700, fontSize: "2.2rem", marginBottom: "1.2rem" }}>
        Refund & Cancellation Policy
      </h1>
      <p style={{ color: "#888", fontSize: "1rem" }}>Last Updated: 7 July 2025</p>
      <p>
        Thank you for choosing <strong>The Karigar Stop (“TKS”)</strong>. We strive to provide you with the best possible experience.
        Please read our Refund and Cancellation Policy carefully to understand your rights and obligations regarding cancellations and refunds for bookings made on our platform.
      </p>

      <h2>1. Service Cancellation by Customer</h2>
      <ul>
        <li>
          <strong>For standard (future-dated) services:</strong>
          <ul>
            <li>
              You may cancel your booking on our website/app before the service provider (Karigar) is dispatched or before the scheduled time.
            </li>
            <li>
              <strong>A cancellation must be made within 24 hours.</strong>
            </li>
            <li>
              If cancelled <strong>at least 24 hours before</strong> the scheduled service, you are eligible for a <strong>full refund</strong> of any amount paid.
            </li>
            <li>
              If cancelled <strong>less than 24 hours</strong> before the scheduled service, a <strong>cancellation fee of up to 20%</strong> of the total service amount may be deducted; the balance will be refunded.
            </li>
          </ul>
        </li>
        <li>
          <strong>For same-day/on-demand services:</strong>
          <ul>
            <li>
              You must cancel <strong>before the serviceman’s OTP (One-Time Password) is generated or shared</strong> for service confirmation.
            </li>
            <li>
              <strong>If you cancel after OTP generation</strong> (i.e., after the serviceman is assigned and dispatched), a <strong>cancellation fee of up to 50%</strong> of the service amount may be charged, and the balance will be refunded.
            </li>
          </ul>
        </li>
      </ul>

      <h2>2. Service Cancellation by The Karigar Stop or Service Provider</h2>
      <p>
        If TKS or the assigned service provider cancels your booking due to unforeseen circumstances, you will receive a <strong>full refund</strong> or may reschedule at no additional cost.
      </p>

      <h2>3. No-show Policy</h2>
      <p>
        If you are unavailable or unreachable at the scheduled time/location, and the provider has arrived or OTP is verified, the booking may be marked as a “no-show.”
        In this case, a <strong>cancellation fee (up to 50%)</strong> may be applicable; the balance will be refunded.
      </p>

      <h2>4. Refund Credited</h2>
      <ul>
        <li>
          Eligible refunds will be <strong>credited</strong> to the original payment method within <strong>7–10 working days</strong> after approval.
        </li>
        <li>
          You will receive email/SMS notifications once your refund has been initiated.
        </li>
      </ul>

      <h2>5. Non-Refundable Situations</h2>
      <ul>
        <li>Services already delivered/completed.</li>
        <li>Partial completion where the customer is satisfied and accepts the work.</li>
        <li>Any consumable or material charges once delivered/used.</li>
      </ul>

      <h2>6. How to Request a Refund or Cancel a Service</h2>
      <ul>
        <li>
          Cancel a booking or request a refund by logging into your account and using the cancellation feature in your booking history.
        </li>
        <li>
          Or contact support at <a href="mailto:thekarigarstop@gmail.com">thekarigarstop@gmail.com</a> or call/WhatsApp <a href="tel:9322883618">9322883618</a>.
        </li>
      </ul>
      <div style={{ marginTop: "1rem", color: "#5B2A93", fontWeight: 500 }}>
        Managed by Akash Nagendra Sharma (Founder) The Karigar Stop
      </div>

      <h2>7. Dispute Resolution</h2>
      <p>
        For any concerns regarding your refund or cancellation, please contact us. We are committed to resolving your issues fairly and promptly.
      </p>

      <hr style={{ margin: "2rem 0" }} />

      <p style={{ fontStyle: "italic", color: "#666" }}>
        <strong>Note:</strong> This policy may be updated from time to time. Please check this page regularly for the latest information.
      </p>

      {/* Footer box */}
      <div
        style={{
          marginTop: "2.5rem",
          padding: "1.2rem 0",
          background: "#f6f1ff",
          textAlign: "center",
          color: "#5B2A93",
          borderRadius: 10,
          fontWeight: 500,
          fontSize: "1rem"
        }}
      >
        <span style={{ margin: "0 10px" }}>
          <a href="/terms-of-service" style={{ color: "#5B2A93" }}>Terms of Service</a>
        </span>
        |
        <span style={{ margin: "0 10px" }}>
          <a href="/privacy-policy" style={{ color: "#5B2A93" }}>Privacy Policy</a>
        </span>
        |
        <span style={{ margin: "0 10px" }}>
          <a href="/refund-cancellation-policy" style={{ color: "#5B2A93" }}>Refund & Cancellation Policy</a>
        </span>
        <br />
        <span style={{ color: "#888", fontSize: "0.85rem", fontWeight: 400 }}>
          &copy; {new Date().getFullYear()} THE KARIGAR STOP. All rights reserved.
        </span>
      </div>
    </div>
  );
};

export default RefundCancellationPolicy;
